import config from '../config';

export const SSO_LOGIN_URL = config.TEST ? 'https://testsso.garena.com/universal/login' : 'https://sso.garena.com/universal/login';
export const SSO_LOGOUT_URL = config.TEST ? 'https://testsso.garena.com/ui/logout' : 'https://sso.garena.com/ui/logout';
export const SSO_CHECK_SESSION_URL = config.TEST ? 'https://testsso.garena.com/api/check_session': 'https://sso.garena.com/api/check_session';
export const CAPTCHA_SERVICE = config.TEST ? 'https://testgop.captcha.garena.com/image' : 'https://gop.captcha.garena.com/image';
export const REDIRECT_URL = {
	'SG': 'https://www.garena.sg/',
	'TH': 'http://www.garena.in.th/',
	'MY': 'https://www.garena.my/',
	'VN': 'https://www.garena.vn/',
	'ID': 'https://www.garena.co.id/',
	'TW': 'https://www.garena.tw/',
}
export const SSO_SETTINGS = {
	'app_id': 10100,
	'language': 'en-SG',
	'login_mode': 'redirect',
	'check_sso_session': true,
	'session_cookie_name': 'session_key',
	'session_cookie_domain': '.garena.com',
	'on_session_change_callback': 'onSsoSessionChange'
};

export const ACCOUNT_SECURITY_BAN_STATUS = 1 << 7;

export const UNLOCK_VERIFY_URL = '/unlock/index';

export const BIND_MOBILE_RELATED_URLS = ['/security/mobile/apply', '/security/mobile/verify', '/security/mobile/save', '/security/mobile/done'];

export const ACTION_TYPE = {
	APPLY_MOBILE: 7,
	VERIFY_MOBILE: 8,
	SAVE_MOBILE: 9,
	APPLY_EMAIL: 10,
	SAVE_EMAIL: 11,
	VERIFY_EMAIL: 12,
	CHANGE_PASSWORD: 13,
	APPLY_AUTHENTICATOR: 14,
	SAVE_AUTHENTICATOR: 15,
	REVOKE_AUTHENTICATOR: 16,
	TWO_STEP_VERIFICATION: 17,
	UNLOCK_VERIFY: 18,
	UNLOCK_CHANGE_PASSWORD: 19,
	CONTACT_CUSTOMER_SERVICE: 20,
	NEED_BIND_MOBILE: 21,
	SAVE_REALINFO: 22,
	PROCEED_FACEBOOK_CONNECT: 23,
	SAVE_GAME_OTP: 24,
	UPDATE_REALINFO: 25,
	DONE: 100,
	DONE_REVOKE: 101,
};

export const STATUS_CODE = {
	EMAIL_EXISTS: 2,
	OTP_LIMIT_EXCEEDED: 3,
	UAC_MISMATCH: 4,
	INCORRECT_PASSWORD: 5,
	OTP_STILL_COOLDOWN: 6,
	INCORRECT_CAPTCHA: 11,
	EMPTY_CAPTCHA: 12,
	INVALID_CAPTCHA_LIMIT_EXCEEDED: 13,
};

export const ACCOUNT_TYPE = {
	UNKNOWN: 0,
	PASSWORD: 1,
	MOBILE: 2,
	EMAIL: 3,
	OTPTOKEN: 4,
	GAME_OTP: 5,
	AUTHENTICATOR: 6,
	REALINFO: 7,
};

export const ACCOUNT_TYPE_TEMPLATE = {
	[ACCOUNT_TYPE.UNKNOWN] : {
		'template_id': 'send_otp_default',
		'template_params': {}
	},
	[ACCOUNT_TYPE.PASSWORD] : {
		'template_id': 'send_otp_change_password',
		'template_params': {}
	},
	[ACCOUNT_TYPE.MOBILE] : {
		'template_id': 'send_otp_verify_mobile',
		'template_params': {}
	},
	[ACCOUNT_TYPE.EMAIL] : {
		'template_id': 'send_otp_change_email',
		'template_params': {}
	},
	[ACCOUNT_TYPE.OTPTOKEN] : {
		'template_id': 'send_otp_revoke_trusted',
		'template_params': {}
	},
	[ACCOUNT_TYPE.GAME_OTP] : {
		'template_id': 'send_otp_game2step',
		'template_params': {}
	},
	[ACCOUNT_TYPE.AUTHENTICATOR]: {
		'template_id': 'send_otp_authenticator',
		'template_params': {}
	},
	[ACCOUNT_TYPE.REALINFO]: {
		'template_id': 'send_otp_update_realinfo',
		'template_params': {}
	},
};

export const VERIFICATION_TOOL = {
	AUTHENTICATOR: 1,
	MOBILE: 2,
	EMAIL: 3
};

export const GAME_OTP_STATUS = {
	DISABLE: 0,
	ENABLE: 1
}

export const ERROR_MESSAGE = {
	ERROR_PARAMS: 'error_params',
	ERROR_SERVER: 'error_server',

	ERROR_REQUEST_ID: 'error_request_id',
	ERROR_NO_APP: 'error_no_app',
	ERROR_TOOL: 'error_tool',
	ERROR_ACTION: 'error_action',
	ERROR_TOKEN: 'error_token',
	ERROR_PASSWORD: 'error_password',
	ERROR_ACCOUNT: 'error_account',
	ERROR_DATA: 'error_data',
	ERROR_CAPTCHA: 'error_captcha',

	ERROR_RETRY: 'error_retry',
	ERROR_LIMIT: 'error_limit',
	ERROR_OTP_LIMIT: 'error_otp_limit',
	ERROR_COOLDOWN: 'error_cooldown',
	ERROR_RATE_LIMIT: 'error_exceed_rate_limit',

	ERROR_CANNOT_RECOVER: 'error_cannot_recover',
	ERROR_SESSION: 'error_session',
	ERROR_ACCOUNTING_COUNTRY: 'error_accounting_country',
	ERROR_TWO_STEP_AUTHENTICATION: 'error_two_step_authentication',
	ERROR_EMAIL_NEED_CONTACT_CS: 'error_email_need_contact_cs',
	ERROR_SUSPICIOUS_IP: 'error_suspicious_ip',
	ERROR_SUSPICIOUS_TOPUP: 'error_suspicious_topup',
	ERROR_SHELL_OVERLIMIT: 'error_shell_overlimit',
	ERROR_SHELL_OVERLIMIT_MY: 'error_shell_overlimit_my',
	ERROR_UAC_CHANGE_LIMIT: 'error_uac_change_limit',
	ERROR_CHANGE_UAC_TRANSACTION_PENDING: 'error_change_uac_transaction_pending',
};

export const LANGUAGES = [
	{ 'country': 'SG', 'locale': 'en-SG', 'lang': 'en', 'name': 'Singapore', 'text': 'English' },
	{ 'country': 'TW', 'locale': 'zh-TW', 'lang': 'zh-TW', 'name': 'Taiwan', 'text': '繁体中文' },
	{ 'country': 'ID', 'locale': 'id-ID', 'lang': 'id', 'name': 'Indonesia', 'text': 'Bahasa' },
	{ 'country': 'VN', 'locale': 'vi-VN', 'lang': 'vi', 'name': 'Vietnam', 'text': 'Tiếng Việt' },
	{ 'country': 'MY', 'locale': 'en-MY', 'lang': 'ms', 'name': 'Malaysia', 'text': 'Malay' },
	{ 'country': 'TH', 'locale': 'th-TH', 'lang': 'th', 'name': 'Thailand', 'text': 'ไทย' },
	{ 'country': 'PH', 'locale': 'en-PH', 'lang': 'en', 'name': 'Philippines', 'text': 'English' },
	{ 'country': 'HK', 'locale': 'zh-TW', 'lang': 'zh-TW', 'name': 'Hong Kong', 'text': '繁体中文' },
	{ 'country': 'MO', 'locale': 'zh-TW', 'lang': 'zh-TW', 'name': 'Macau', 'text': '繁体中文' }
];

export const COUNTRY_NEED_REVOKE_TOKEN = ["TW", "HK", "MO"];

export const COUNTRY_NEED_REAL_INFO = ["SG", "MY", "ID", "PH", "VN", "TW", "HK", "MO"];

export const COUNTRY_NEED_REAL_INFO_BIRTHDAY = ["TW", "HK", "MO"];

export const COUNTRY_NEED_FACEBOOK_CONNECT = ['SG', 'VN'];

export const COUNTRY_NEED_GAME_OTP = [];

export const MOBILE_COUNTRY_CODES = [
	{ 'country': 'CA/US', 'code': '1', 'text': '+ 1' },
	{ 'country': 'BS', 'code': '1242', 'text': '+ 1242' },
	{ 'country': 'BB', 'code': '1246', 'text': '+ 1246' },
	{ 'country': 'AI', 'code': '1264', 'text': '+ 1264' },
	{ 'country': 'AG', 'code': '1268', 'text': '+ 1268' },
	{ 'country': 'VG', 'code': '1284', 'text': '+ 1284' },
	{ 'country': 'VI', 'code': '1340', 'text': '+ 1340' },
	{ 'country': 'KY', 'code': '1345', 'text': '+ 1345' },
	{ 'country': 'BM', 'code': '1441', 'text': '+ 1441' },
	{ 'country': 'GD', 'code': '1473', 'text': '+ 1473' },
	{ 'country': 'TC', 'code': '1649', 'text': '+ 1649' },
	{ 'country': 'MS', 'code': '1664', 'text': '+ 1664' },
	{ 'country': 'GU', 'code': '1671', 'text': '+ 1671' },
	{ 'country': 'AS', 'code': '1684', 'text': '+ 1684' },
	{ 'country': 'LC', 'code': '1758', 'text': '+ 1758' },
	{ 'country': 'DM', 'code': '1767', 'text': '+ 1767' },
	{ 'country': 'VC', 'code': '1784', 'text': '+ 1784' },
	{ 'country': 'PR', 'code': '1787', 'text': '+ 1787' },
	{ 'country': 'DO', 'code': '1809', 'text': '+ 1809' },
	{ 'country': 'TT', 'code': '1868', 'text': '+ 1868' },
	{ 'country': 'KN', 'code': '1869', 'text': '+ 1869' },
	{ 'country': 'JM', 'code': '1876', 'text': '+ 1876' },
	{ 'country': 'RE', 'code': '262', 'text': '+ 262' },
	{ 'country': 'EG', 'code': '20', 'text': '+ 20' },
	{ 'country': 'EH/MA', 'code': '212', 'text': '+ 212' },
	{ 'country': 'DZ', 'code': '213', 'text': '+ 213' },
	{ 'country': 'TN', 'code': '216', 'text': '+ 216' },
	{ 'country': 'LY', 'code': '218', 'text': '+ 218' },
	{ 'country': 'GM', 'code': '220', 'text': '+ 220' },
	{ 'country': 'SN', 'code': '221', 'text': '+ 221' },
	{ 'country': 'MR', 'code': '222', 'text': '+ 222' },
	{ 'country': 'ML', 'code': '223', 'text': '+ 223' },
	{ 'country': 'GN', 'code': '224', 'text': '+ 224' },
	{ 'country': 'CI', 'code': '225', 'text': '+ 225' },
	{ 'country': 'BF', 'code': '226', 'text': '+ 226' },
	{ 'country': 'NE', 'code': '227', 'text': '+ 227' },
	{ 'country': 'TG', 'code': '228', 'text': '+ 228' },
	{ 'country': 'BJ', 'code': '229', 'text': '+ 229' },
	{ 'country': 'MU', 'code': '230', 'text': '+ 230' },
	{ 'country': 'LR', 'code': '231', 'text': '+ 231' },
	{ 'country': 'SL', 'code': '232', 'text': '+ 232' },
	{ 'country': 'GH', 'code': '233', 'text': '+ 233' },
	{ 'country': 'NG', 'code': '234', 'text': '+ 234' },
	{ 'country': 'TD', 'code': '235', 'text': '+ 235' },
	{ 'country': 'CF', 'code': '236', 'text': '+ 236' },
	{ 'country': 'CM', 'code': '237', 'text': '+ 237' },
	{ 'country': 'CV', 'code': '238', 'text': '+ 238' },
	{ 'country': 'ST', 'code': '239', 'text': '+ 239' },
	{ 'country': 'GQ', 'code': '240', 'text': '+ 240' },
	{ 'country': 'GA', 'code': '241', 'text': '+ 241' },
	{ 'country': 'CG', 'code': '242', 'text': '+ 242' },
	{ 'country': 'CD', 'code': '243', 'text': '+ 243' },
	{ 'country': 'AO', 'code': '244', 'text': '+ 244' },
	{ 'country': 'GW', 'code': '245', 'text': '+ 245' },
	{ 'country': 'IO', 'code': '246', 'text': '+ 246' },
	{ 'country': 'AC', 'code': '247', 'text': '+ 247' },
	{ 'country': 'SC', 'code': '248', 'text': '+ 248' },
	{ 'country': 'SD', 'code': '249', 'text': '+ 249' },
	{ 'country': 'RW', 'code': '250', 'text': '+ 250' },
	{ 'country': 'ET', 'code': '251', 'text': '+ 251' },
	{ 'country': 'SO', 'code': '252', 'text': '+ 252' },
	{ 'country': 'DJ', 'code': '253', 'text': '+ 253' },
	{ 'country': 'KE', 'code': '254', 'text': '+ 254' },
	{ 'country': 'TZ', 'code': '255', 'text': '+ 255' },
	{ 'country': 'UG', 'code': '256', 'text': '+ 256' },
	{ 'country': 'BI', 'code': '257', 'text': '+ 257' },
	{ 'country': 'MZ', 'code': '258', 'text': '+ 258' },
	{ 'country': 'ZM', 'code': '260', 'text': '+ 260' },
	{ 'country': 'MG', 'code': '261', 'text': '+ 261' },
	{ 'country': 'RE/YT', 'code': '262', 'text': '+ 262' },
	{ 'country': 'ZW', 'code': '263', 'text': '+ 263' },
	{ 'country': 'NA', 'code': '264', 'text': '+ 264' },
	{ 'country': 'MW', 'code': '265', 'text': '+ 265' },
	{ 'country': 'LS', 'code': '266', 'text': '+ 266' },
	{ 'country': 'BW', 'code': '267', 'text': '+ 267' },
	{ 'country': 'SZ', 'code': '268', 'text': '+ 268' },
	{ 'country': 'KM', 'code': '269', 'text': '+ 269' },
	{ 'country': 'ZA', 'code': '27', 'text': '+ 27' },
	{ 'country': 'SH', 'code': '290', 'text': '+ 290' },
	{ 'country': 'ER', 'code': '291', 'text': '+ 291' },
	{ 'country': 'AW', 'code': '297', 'text': '+ 297' },
	{ 'country': 'FO', 'code': '298', 'text': '+ 298' },
	{ 'country': 'GL', 'code': '299', 'text': '+ 299' },
	{ 'country': 'GR', 'code': '30', 'text': '+ 30' },
	{ 'country': 'NL', 'code': '31', 'text': '+ 31' },
	{ 'country': 'BE', 'code': '32', 'text': '+ 32' },
	{ 'country': 'FR', 'code': '33', 'text': '+ 33' },
	{ 'country': 'ES', 'code': '34', 'text': '+ 34' },
	{ 'country': 'GI', 'code': '350', 'text': '+ 350' },
	{ 'country': 'PT', 'code': '351', 'text': '+ 351' },
	{ 'country': 'LU', 'code': '352', 'text': '+ 352' },
	{ 'country': 'IE', 'code': '353', 'text': '+ 353' },
	{ 'country': 'IS', 'code': '354', 'text': '+ 354' },
	{ 'country': 'AL', 'code': '355', 'text': '+ 355' },
	{ 'country': 'MT', 'code': '356', 'text': '+ 356' },
	{ 'country': 'CY', 'code': '357', 'text': '+ 357' },
	{ 'country': 'FI', 'code': '358', 'text': '+ 358' },
	{ 'country': 'BG', 'code': '359', 'text': '+ 359' },
	{ 'country': 'HU', 'code': '36', 'text': '+ 36' },
	{ 'country': 'LT', 'code': '370', 'text': '+ 370' },
	{ 'country': 'LV', 'code': '371', 'text': '+ 371' },
	{ 'country': 'EE', 'code': '372', 'text': '+ 372' },
	{ 'country': 'MD', 'code': '373', 'text': '+ 373' },
	{ 'country': 'AM', 'code': '374', 'text': '+ 374' },
	{ 'country': 'BY', 'code': '375', 'text': '+ 375' },
	{ 'country': 'AD', 'code': '376', 'text': '+ 376' },
	{ 'country': 'MC', 'code': '377', 'text': '+ 377' },
	{ 'country': 'SM', 'code': '378', 'text': '+ 378' },
	{ 'country': 'VA', 'code': '379', 'text': '+ 379' },
	{ 'country': 'UA', 'code': '380', 'text': '+ 380' },
	{ 'country': 'RS', 'code': '381', 'text': '+ 381' },
	{ 'country': 'ME', 'code': '382', 'text': '+ 382' },
	{ 'country': 'HR', 'code': '385', 'text': '+ 385' },
	{ 'country': 'SI', 'code': '386', 'text': '+ 386' },
	{ 'country': 'BA', 'code': '387', 'text': '+ 387' },
	{ 'country': 'MK', 'code': '389', 'text': '+ 389' },
	{ 'country': 'IT', 'code': '39', 'text': '+ 39' },
	{ 'country': 'RO', 'code': '40', 'text': '+ 40' },
	{ 'country': 'CH', 'code': '41', 'text': '+ 41' },
	{ 'country': 'CZ', 'code': '420', 'text': '+ 420' },
	{ 'country': 'SK', 'code': '421', 'text': '+ 421' },
	{ 'country': 'LI', 'code': '423', 'text': '+ 423' },
	{ 'country': 'AT', 'code': '43', 'text': '+ 43' },
	{ 'country': 'UK', 'code': '44', 'text': '+ 44' },
	{ 'country': 'JE', 'code': '44', 'text': '+ 44' },
	{ 'country': 'GG', 'code': '44', 'text': '+ 44' },
	{ 'country': 'GB', 'code': '44', 'text': '+ 44' },
	{ 'country': 'IM', 'code': '44', 'text': '+ 44' },
	{ 'country': 'DK', 'code': '45', 'text': '+ 45' },
	{ 'country': 'SE', 'code': '46', 'text': '+ 46' },
	{ 'country': 'NO', 'code': '47', 'text': '+ 47' },
	{ 'country': 'PL', 'code': '48', 'text': '+ 48' },
	{ 'country': 'DE', 'code': '49', 'text': '+ 49' },
	{ 'country': 'FK', 'code': '500', 'text': '+ 500' },
	{ 'country': 'BZ', 'code': '501', 'text': '+ 501' },
	{ 'country': 'GT', 'code': '502', 'text': '+ 502' },
	{ 'country': 'SV', 'code': '503', 'text': '+ 503' },
	{ 'country': 'HN', 'code': '504', 'text': '+ 504' },
	{ 'country': 'NI', 'code': '505', 'text': '+ 505' },
	{ 'country': 'CR', 'code': '506', 'text': '+ 506' },
	{ 'country': 'PA', 'code': '507', 'text': '+ 507' },
	{ 'country': 'PM', 'code': '508', 'text': '+ 508' },
	{ 'country': 'HT', 'code': '509', 'text': '+ 509' },
	{ 'country': 'PE', 'code': '51', 'text': '+ 51' },
	{ 'country': 'MX', 'code': '52', 'text': '+ 52' },
	{ 'country': 'CU', 'code': '53', 'text': '+ 53' },
	{ 'country': 'AR', 'code': '54', 'text': '+ 54' },
	{ 'country': 'BR', 'code': '55', 'text': '+ 55' },
	{ 'country': 'CL', 'code': '56', 'text': '+ 56' },
	{ 'country': 'CO', 'code': '57', 'text': '+ 57' },
	{ 'country': 'VE', 'code': '58', 'text': '+ 58' },
	{ 'country': 'GP', 'code': '590', 'text': '+ 590' },
	{ 'country': 'BO', 'code': '591', 'text': '+ 591' },
	{ 'country': 'GY', 'code': '592', 'text': '+ 592' },
	{ 'country': 'EC', 'code': '593', 'text': '+ 593' },
	{ 'country': 'GF', 'code': '594', 'text': '+ 594' },
	{ 'country': 'PY', 'code': '595', 'text': '+ 595' },
	{ 'country': 'MQ', 'code': '596', 'text': '+ 596' },
	{ 'country': 'SR', 'code': '597', 'text': '+ 597' },
	{ 'country': 'UY', 'code': '598', 'text': '+ 598' },
	{ 'country': 'AN', 'code': '599', 'text': '+ 599' },
	{ 'country': 'MY', 'code': '60', 'text': '+ 60' },
	{ 'country': 'AU', 'code': '61', 'text': '+ 61' },
	{ 'country': 'ID', 'code': '62', 'text': '+ 62' },
	{ 'country': 'PH', 'code': '63', 'text': '+ 63' },
	{ 'country': 'NZ', 'code': '64', 'text': '+ 64' },
	{ 'country': 'SG', 'code': '65', 'text': '+ 65' },
	{ 'country': 'TH', 'code': '66', 'text': '+ 66' },
	{ 'country': 'TL', 'code': '670', 'text': '+ 670' },
	{ 'country': 'BN', 'code': '673', 'text': '+ 673' },
	{ 'country': 'NR', 'code': '674', 'text': '+ 674' },
	{ 'country': 'PG', 'code': '675', 'text': '+ 675' },
	{ 'country': 'TO', 'code': '676', 'text': '+ 676' },
	{ 'country': 'SB', 'code': '677', 'text': '+ 677' },
	{ 'country': 'VU', 'code': '678', 'text': '+ 678' },
	{ 'country': 'FJ', 'code': '679', 'text': '+ 679' },
	{ 'country': 'PW', 'code': '680', 'text': '+ 680' },
	{ 'country': 'WF', 'code': '681', 'text': '+ 681' },
	{ 'country': 'CK', 'code': '682', 'text': '+ 682' },
	{ 'country': 'NU', 'code': '683', 'text': '+ 683' },
	{ 'country': 'WS', 'code': '685', 'text': '+ 685' },
	{ 'country': 'KI', 'code': '686', 'text': '+ 686' },
	{ 'country': 'NC', 'code': '687', 'text': '+ 687' },
	{ 'country': 'TV', 'code': '688', 'text': '+ 688' },
	{ 'country': 'PF', 'code': '689', 'text': '+ 689' },
	{ 'country': 'TK', 'code': '690', 'text': '+ 690' },
	{ 'country': 'FM', 'code': '691', 'text': '+ 691' },
	{ 'country': 'MH', 'code': '692', 'text': '+ 692' },
	{ 'country': 'RU/KZ', 'code': '7', 'text': '+ 7' },
	{ 'country': 'JP', 'code': '81', 'text': '+ 81' },
	{ 'country': 'KR', 'code': '82', 'text': '+ 82' },
	{ 'country': 'VN', 'code': '84', 'text': '+ 84' },
	{ 'country': 'KP', 'code': '850', 'text': '+ 850' },
	{ 'country': 'HK', 'code': '852', 'text': '+ 852' },
	{ 'country': 'MO', 'code': '853', 'text': '+ 853' },
	{ 'country': 'KH', 'code': '855', 'text': '+ 855' },
	{ 'country': 'LA', 'code': '856', 'text': '+ 856' },
	{ 'country': 'CN', 'code': '86', 'text': '+ 86' },
	{ 'country': 'BD', 'code': '880', 'text': '+ 880' },
	{ 'country': 'TW', 'code': '886', 'text': '+ 886' },
	{ 'country': 'TR', 'code': '90', 'text': '+ 90' },
	{ 'country': 'IN', 'code': '91', 'text': '+ 91' },
	{ 'country': 'PK', 'code': '92', 'text': '+ 92' },
	{ 'country': 'AF', 'code': '93', 'text': '+ 93' },
	{ 'country': 'LK', 'code': '94', 'text': '+ 94' },
	{ 'country': 'MM', 'code': '95', 'text': '+ 95' },
	{ 'country': 'MV', 'code': '960', 'text': '+ 960' },
	{ 'country': 'LB', 'code': '961', 'text': '+ 961' },
	{ 'country': 'JO', 'code': '962', 'text': '+ 962' },
	{ 'country': 'SY', 'code': '963', 'text': '+ 963' },
	{ 'country': 'IQ', 'code': '964', 'text': '+ 964' },
	{ 'country': 'KW', 'code': '965', 'text': '+ 965' },
	{ 'country': 'SA', 'code': '966', 'text': '+ 966' },
	{ 'country': 'YE', 'code': '967', 'text': '+ 967' },
	{ 'country': 'OM', 'code': '968', 'text': '+ 968' },
	{ 'country': 'PS', 'code': '970', 'text': '+ 970' },
	{ 'country': 'AE', 'code': '971', 'text': '+ 971' },
	{ 'country': 'IL', 'code': '972', 'text': '+ 972' },
	{ 'country': 'BH', 'code': '973', 'text': '+ 973' },
	{ 'country': 'QA', 'code': '974', 'text': '+ 974' },
	{ 'country': 'BT', 'code': '975', 'text': '+ 975' },
	{ 'country': 'MN', 'code': '976', 'text': '+ 976' },
	{ 'country': 'NP', 'code': '977', 'text': '+ 977' },
	{ 'country': 'IR', 'code': '98', 'text': '+ 98' },
	{ 'country': 'TJ', 'code': '992', 'text': '+ 992' },
	{ 'country': 'TM', 'code': '993', 'text': '+ 993' },
	{ 'country': 'AZ', 'code': '994', 'text': '+ 994' },
	{ 'country': 'GE', 'code': '995', 'text': '+ 995' },
	{ 'country': 'KG', 'code': '996', 'text': '+ 996' },
	{ 'country': 'UZ', 'code': '998', 'text': '+ 998' }
];

export const CUSTOM_SERVICE_URL = {
	'SG': 'https://sg.support.garena.com/',
	'MY': 'https://my.support.garena.com/',
	'ID': 'https://www.garena.co.id/support/general/',
	'TW': 'https://tw.support.garena.com/',
	'HK': 'https://tw.support.garena.com/',
	'MO': 'https://tw.support.garena.com/',
	'TH': 'http://www.garena.in.th/customer',
	'VN': 'https://hotro.garena.vn/',
	'PH': 'https://ph.support.garena.com/',
	'RU': 'https://support.garena.ru/',
	'INTL': 'https://sg.support.garena.com/'
};

export const TERM_OF_SERVICE_URL = {
	'SG': 'https://contentgarena-a.akamaihd.net/legal/tos/tos_en.html',
	'MY': 'https://contentgarena-a.akamaihd.net/legal/tos/tos_en.html',
	'ID': 'https://contentgarena-a.akamaihd.net/legal/tos/tos_id.html',
	'TW': 'https://contentgarena-a.akamaihd.net/legal/tos/tos_zh-TW.html',
	'HK': 'https://contentgarena-a.akamaihd.net/legal/tos/tos_zh-TW.html',
	'MO': 'https://contentgarena-a.akamaihd.net/legal/tos/tos_zh-TW.html',
	'TH': 'https://contentgarena-a.akamaihd.net/legal/tos/tos_th.html',
	'VN': 'https://contentgarena-a.akamaihd.net/legal/tos/tos_vn.html',
	'PH': 'https://contentgarena-a.akamaihd.net/legal/tos/tos_en.html',
	'RU': 'https://contentgarena-a.akamaihd.net/legal/tos/tos_en.html',
	'INTL': 'https://contentgarena-a.akamaihd.net/legal/tos/tos_en.html'
};

export const PRIVACY_URL = {
	'SG': 'https://contentgarena-a.akamaihd.net/legal/pp/pp_en.html',
	'MY': 'https://contentgarena-a.akamaihd.net/legal/pp/pp_en.html',
	'ID': 'https://contentgarena-a.akamaihd.net/legal/pp/pp_id.html',
	'TW': 'https://contentgarena-a.akamaihd.net/legal/pp/pp_zh-TW.html',
	'HK': 'https://contentgarena-a.akamaihd.net/legal/pp/pp_zh-TW.html',
	'MO': 'https://contentgarena-a.akamaihd.net/legal/pp/pp_zh-TW.html',
	'TH': 'https://contentgarena-a.akamaihd.net/legal/pp/pp_th.html',
	'VN': 'https://contentgarena-a.akamaihd.net/legal/pp/pp_vn.html',
	'PH': 'https://contentgarena-a.akamaihd.net/legal/pp/pp_en.html',
	'RU': 'https://contentgarena-a.akamaihd.net/legal/pp/pp_en.html',
	'INTL': 'https://contentgarena-a.akamaihd.net/legal/pp/pp_en.html'
};

export const MINMINAL_ID_CARD_LENGTH = 9;
export const MINMINAL_UPDATE_ID_CARD_LENGTH = 12;

export const BIRTHDAY_REGEX = /^\d{4}([./-])\d{2}\1\d{2}$/;

export const SAMPLE_BIRTHDAY = "1992-01-01";

export const BIRTHDAY_STR_LENGTH = 10;

export const FB_GAS_APP_ID = '350791651640893';
export const FACEBOOK_OAUTH_URL = 'https://www.facebook.com/dialog/oauth';

export const CSRF_COOKIE_NAME = '__csrf__';
export const CSRF_HEADER_NAME = 'x-csrf-token';
export const FAKE_CSRF_TOKEN = 'FAKE_TOKEN';

export const EMAIL_VERIFICATION_ENABLED_ACCOUNT_TYPES = [ACCOUNT_TYPE.PASSWORD, ACCOUNT_TYPE.MOBILE, ACCOUNT_TYPE.AUTHENTICATOR, ACCOUNT_TYPE.REALINFO]
export const AUTHENTICATOR_ALGORITHM = {
	GARENA: 1,
	GOOGLE: 2,
}
export const EMAIL_VERIFICATION_AGE_TO_UPDATE_REALINFO = 30 * 24 * 60 * 60 // 30 days

export const GARENA_CAPTCHA_LENGHT = 6;



// WEBPACK FOOTER //
// ./app/constants.js